module.exports = __webpack_public_path__ + "static/media/biteship-magento.3f3e47f4.png";